module.exports = __webpack_public_path__ + "media/eastern-wood-pewee-1.8b1deb8f.mp3";